<template>
  <v-footer
    dark
    height="auto"
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="teal">
        <strong class="subheading font-weight-strong mb-6">{{$t('footer.TITLE')}}</strong>
        <v-btn
          v-for="icon in icons"
          :key="icon"
          class="mx-3"
          dark
          icon
        >
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>

      </v-card-title>

      <v-card-actions class="grey darken-3 justify-center">
        &copy;2021 — <strong>ShaYoFaE - Betadigitis SAS</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        'fab fa-facebook',
        'fab fa-twitter',
        'fab fa-linkedin'
      ]
    }
  }
}
</script>
